import { Component, ComponentInterface, Element, h, Host, JSX, Listen, Prop } from '@stencil/core';
import { SharedDirectionService } from '../../global/init-services';
import { getDataOnFromTheme, WorkbenchTheme } from '../../shared/themes';

/**
 * Skeleton screens should leave the impression of a short loading time. This is achieved by displaying the Skeleton,
 * the basic structure of the website, as quickly as possible. This frame is then step by step filled with content.
 * The Skeleton screen is used to communicate that the user will quickly receive content. They will know that the page
 * is not yet fully loaded, but the information will be displayed soon. The Skeleton is used to show immediate content
 * before the final one.
 */
@Component({
  tag: 'wb-skeleton',
  styleUrl: './skeleton.scss',
  shadow: true,
})
export class SkeletonComponent implements ComponentInterface {
  @Element()
  public el: HTMLElement;

  /**
   * Colour scheme
   * @deprecated Use `data-on` attribute instead
   * */
  @Prop({ reflect: true })
  public theme: WorkbenchTheme;

  /** @internal if present sets the direction of the element to rtl */
  @Prop({ reflect: true, mutable: true })
  public isRtl: boolean = false;

  @Listen('wbdirchange', { target: 'document' })
  public updateDirection() {
    this.isRtl = SharedDirectionService.isRtl;
  }

  public connectedCallback() {
    this.updateDirection();
  }

  public render(): JSX.Element {
    return <Host class="wb-skeleton" data-on={getDataOnFromTheme(this.el, this.theme)} />;
  }
}
